import ContractActivityDetails from './DimensionListActivityDetails';

export default ContractActivityDetails;
